import PropTypes from "prop-types";

import { BudgetingGame } from "@features/budgeting-game";
import { Sheet } from "@features/ui";

export const BudgetingGameSheet = ({
  onBudgetingGameComplete,
  onClose,
  open,
}) => {
  return (
    <Sheet open={open}>
      <BudgetingGame
        onClose={onClose}
        onBudgetingGameComplete={onBudgetingGameComplete}
      />
    </Sheet>
  );
};

BudgetingGameSheet.displayName = "Budgeting Game Sheet";

BudgetingGameSheet.propTypes = {
  onBudgetingGameComplete: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
